var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AppPageFW,[_c('div',{staticClass:"container"},[_c('span',{staticClass:"unlocking"},[_vm._v(" Unlocking ... ")]),_c(_setup.AppLoading)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }